// extracted by mini-css-extract-plugin
module.exports = {"section":"Share_section__NUCIY","divider":"Share_divider__xoBNZ","group":"Share_group__ePWKI"};